// SearchBlock.jsx
import React, { useEffect, useRef } from 'react'
import { Search } from './Search'
import SelectComponent from '../SelectComponent'
import SortPanel from './SortPanel'
import { selectItemSearchProduct } from '../../store/localItems'

const DEFAULT_PRODUCT_SEARCH_MODE = 'allParameters'

const SearchBlock = ({
    setSearchMainName,
    setSortSearch,
    productSort,
    sortSearch,
    sortType,
    search,
    get,
    additionalData,
    setPageNumber,
    embedded = false,
}) => {
    const defaultAppliedRef = useRef(false)

    useEffect(() => {
        if (
            defaultAppliedRef.current
            || !productSort
            || typeof setSortSearch !== 'function'
        ) {
            return
        }

        defaultAppliedRef.current = true

        if (sortSearch !== DEFAULT_PRODUCT_SEARCH_MODE) {
            setSortSearch(DEFAULT_PRODUCT_SEARCH_MODE)
        }
    }, [productSort, setSortSearch, sortSearch])

    const activeSearchMode = (
        productSort && !defaultAppliedRef.current
            ? DEFAULT_PRODUCT_SEARCH_MODE
            : (sortSearch || DEFAULT_PRODUCT_SEARCH_MODE)
    )

    const content = (
        <div className="disk__searchContainer">
            <div className="disk__searchField">
                <label className="disk__controlLabel">Поиск</label>
                <Search
                    sortSearch={activeSearchMode}
                    search={search}
                    setSearchMainName={setSearchMainName}
                    sortType={sortType}
                    productSort={productSort}
                    get={get || null}
                    additionalData={additionalData}
                    setPageNumber={setPageNumber}
                    placeholder="Поиск"
                />
            </div>

            {productSort ? (
                <SelectComponent
                    title="Искать по"
                    selectItem={selectItemSearchProduct}
                    value={activeSearchMode}
                    handleChange={(e) => setSortSearch?.(e.target.value)}
                    minWidth={270}
                />
            ) : null}
        </div>
    )

    if (embedded) {
        return (
            <div className="disk__searchGroup">
                {content}
            </div>
        )
    }

    return (
        <SortPanel title="Поиск">
            {content}
        </SortPanel>
    )
}

export default SearchBlock
